module.exports = __webpack_public_path__ + "static/img/timg.de5ee42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/timg.jpg
// module id = aR6W
// module chunks = 1